import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_URL from '../api/baseURL';

const MaintenanceHistory = ({ vehicleId, token }) => {
  const [history, setHistory] = useState([]);
  const [expandedLogs, setExpandedLogs] = useState({});

  useEffect(() => {
    if (!vehicleId || !token) return;
    fetchLogs();
    // eslint-disable-next-line
  }, [vehicleId, token]);

  const fetchLogs = async () => {
    try {
      const res = await axios.get(`${API_URL}/maintenance/history/${vehicleId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHistory(res.data);
    } catch (err) {
      console.error("Failed to fetch maintenance logs:", err);
    }
  };

  const toggleExpand = (id) => {
    setExpandedLogs(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="mt-10 text-sm">
      <h3 className="text-xl font-bold mb-4">🛠️ Maintenance History</h3>
      {history.map(entry => (
        <div key={entry._id} className="mb-4 bg-gray-800 text-white rounded shadow">
          <div className="p-3 flex justify-between cursor-pointer" onClick={() => toggleExpand(entry._id)}>
            <div>
              <strong>{entry.workshop?.businessName || "Workshop"}</strong> - {entry.date ? new Date(entry.date).toLocaleDateString() : 'No Date'}
            </div>
            <div>{entry.totalCost?.toLocaleString() || 0} FCFA</div>
          </div>
          {expandedLogs[entry._id] && (
            <div className="p-4 border-t border-gray-700">
              <div className="mb-2">
                <strong>Technician:</strong> {entry.technician || "N/A"} <br />
                <strong>Status:</strong> {entry.status || "N/A"} <br />
                <strong>Odometer:</strong>
                {entry.odometerReading !== undefined && entry.odometerReading !== null
                  ? ` ${entry.odometerReading} km`
                  : ' N/A'
                } <br />
                <strong>Service Type:</strong> {entry.serviceReason || "N/A"} <br />
                {/* Remove duration/warranty if not in model */}
              </div>
              <div className="mt-4">
                <h4 className="font-bold">Spare Parts Used</h4>
                <table className="w-full text-left text-xs">
                  <thead>
                    <tr className="border-b border-gray-700">
                      <th className="py-1">Part</th>
                      <th className="py-1">Ref.</th>
                      <th className="py-1">Brand</th>
                      <th className="py-1">Qty</th>
                      <th className="py-1">Unit Price</th>
                      <th className="py-1">Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entry.partsUsed && entry.partsUsed.length > 0 ? (
                      entry.partsUsed.map((part, idx) => (
                        <tr key={idx}>
                          <td className="py-1">{part.description}</td>
                          <td className="py-1">{part.reference}</td>
                          <td className="py-1">{part.brand}</td>
                          <td className="py-1">{part.quantity}</td>
                          <td className="py-1">{part.price?.toLocaleString() || 0} FCFA</td>
                          <td className="py-1">{((part.price || 0) * (part.quantity || 1)).toLocaleString()} FCFA</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-gray-400 italic text-center py-2">
                          No parts used
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="mt-2">
                  <strong>Labor Cost:</strong> {entry.laborCost?.toLocaleString() || 0} FCFA<br />
                  <strong>Notes:</strong> {entry.notes || "No additional notes."}
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MaintenanceHistory;
